import { tryCatchHelper } from '../../helpers';
import { oneEntidadesAction } from '../entidad/entidades/EntidadesAction';
import {
  ACTIVO_DIRECCIONES,
  ALL_DIRECCIONES,
  LOADING_ALL_DIRECCIONES,
} from './DireccionesReducer';
import {
  deleteDireccionesService,
  allDireccionesService,
  oneDireccionesService,
  saveDireccionesService,
} from './DireccionesService';

export const allDireccionesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_DIRECCIONES, payload: true });
    const res = await allDireccionesService(params);
    dispatch({ type: ALL_DIRECCIONES, payload: res.data });
    dispatch({ type: LOADING_ALL_DIRECCIONES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_DIRECCIONES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveDireccionesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveDireccionesService(id, data);
    notify(res.data.message);
    if (params.usuario) {
      await allDireccionesAction(dispatch, params);
    }

    if (params.idEntidad) {
      await oneEntidadesAction(dispatch, params.idEntidad);
    }

    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoDireccionesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_DIRECCIONES, payload: data });
};

export const oneDireccionesAction = async (dispatch, idUsuario, id) => {
  try {
    const res = await oneDireccionesService(idUsuario, id);
    await setActivoDireccionesAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteDireccionesAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteDireccionesService(id);
    notify(res.data.message);
    await setActivoDireccionesAction(dispatch, null);
    await allDireccionesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
